export const EventTypes = ['message', 'ping', 'init', 'event'];

const EventSource = (function (global) {
  let setTimeout = global.setTimeout;
  let clearTimeout = global.clearTimeout;

  function Map() {
    this.data = {};
  }

  Map.prototype.get = function (key) {
    return this.data[key + '~'];
  };
  Map.prototype.set = function (key, value) {
    this.data[key + '~'] = value;
  };
  Map.prototype['delete'] = function (key) {
    delete this.data[key + '~'];
  };

  function EventTarget() {
    this.listeners = new Map();
  }

  function throwError(e) {
    setTimeout(function () {
      throw e;
    }, 0);
  }

  EventTarget.prototype.dispatchEvent = function (event) {
    event.target = this;
    let type = event.type.toString();
    let listeners = this.listeners;
    let typeListeners = listeners.get(type);
    if (typeListeners === undefined) {
      return;
    }
    let length = typeListeners.length;
    let i = -1;
    let listener = undefined;
    while (++i < length) {
      listener = typeListeners[i];
      try {
        listener.call(this, event);
      } catch (e) {
        throwError(e);
      }
    }
  };
  EventTarget.prototype.addEventListener = function (type, callback) {
    type = type.toString();
    let listeners = this.listeners;
    let typeListeners = listeners.get(type);
    if (typeListeners === undefined) {
      typeListeners = [];
      listeners.set(type, typeListeners);
    }
    let i = typeListeners.length;
    while (--i >= 0) {
      if (typeListeners[i] === callback) {
        return;
      }
    }
    typeListeners.push(callback);
  };
  EventTarget.prototype.removeEventListener = function (type, callback) {
    type = type.toString();
    let listeners = this.listeners;
    let typeListeners = listeners.get(type);
    if (typeListeners === undefined) {
      return;
    }
    let length = typeListeners.length;
    let filtered = [];
    let i = -1;
    while (++i < length) {
      if (typeListeners[i] !== callback) {
        filtered.push(typeListeners[i]);
      }
    }
    if (filtered.length === 0) {
      listeners['delete'](type);
    } else {
      listeners.set(type, filtered);
    }
  };

  function Event(type) {
    this.type = type;
    this.target = undefined;
  }

  function MessageEvent(type, options) {
    Event.call(this, type);
    this.data = options.data;
    this.lastEventId = options.lastEventId;
  }

  MessageEvent.prototype = Event.prototype;

  let XHR = global.XMLHttpRequest;
  let XDR = global.XDomainRequest;
  let isCORSSupported = XHR !== undefined && new XHR().withCredentials !== undefined;
  let Transport = isCORSSupported || (XHR !== undefined && XDR === undefined) ? XHR : XDR;

  let WAITING = -1;
  let CONNECTING = 0;
  let OPEN = 1;
  let CLOSED = 2;
  let AFTER_CR = 3;
  let FIELD_START = 4;
  let FIELD = 5;
  let VALUE_START = 6;
  let VALUE = 7;
  let contentTypeRegExp = /^text\/event-stream;?(\s*charset=utf-8)?$/i;

  let MINIMUM_DURATION = 1000;
  let MAXIMUM_DURATION = 18000000;

  function getDuration(value, def) {
    let n = value;
    return n < MINIMUM_DURATION ? MINIMUM_DURATION : n > MAXIMUM_DURATION ? MAXIMUM_DURATION : n;
  }

  function fire(that, f, event) {
    try {
      if (typeof f === 'function') {
        f.call(that, event);
      }
    } catch (e) {
      throwError(e);
    }
  }

  function EventSource(url, options) {
    url = url.toString();

    let withCredentials = isCORSSupported && options !== undefined && Boolean(options.withCredentials);
    let initialRetry = getDuration(1000, 0);
    let heartbeatTimeout = getDuration(45000, 0);

    let lastEventId = '';
    let headers = (options && options.headers) || {};
    let that = this;
    let retry = initialRetry;
    let wasActivity = false;
    let CurrentTransport = options !== undefined && options.Transport !== undefined ? options.Transport : Transport;
    let xhr = new CurrentTransport();
    let timeout = 0;
    let timeout0 = 0;
    let charOffset = 0;
    let currentState = WAITING;
    let dataBuffer = [];
    let lastEventIdBuffer = '';
    let eventTypeBuffer = '';
    let onTimeout = undefined;
    let tokenExpired = false;

    let state = FIELD_START;
    let field = '';
    let value = '';

    function close() {
      currentState = CLOSED;
      if (xhr !== undefined) {
        xhr.abort();
        xhr = undefined;
      }
      if (timeout !== 0) {
        clearTimeout(timeout);
        timeout = 0;
      }
      if (timeout0 !== 0) {
        clearTimeout(timeout0);
        timeout0 = 0;
      }
      that.readyState = CLOSED;
    }

    function onEvent(type) {
      let responseText = '';
      if (currentState === OPEN || currentState === CONNECTING) {
        try {
          responseText = xhr.responseText;
        } catch (error) {
          // IE 8 - 9 with XMLHttpRequest
        }
      }
      let event = undefined;
      let isWrongStatusCodeOrContentType = false;

      if (currentState === CONNECTING) {
        let status = 0;
        let statusText = '';
        let contentType = undefined;
        if (!('contentType' in xhr)) {
          try {
            status = xhr.status;
            statusText = xhr.statusText;
            contentType = xhr.getResponseHeader('Content-Type');
          } catch (error) {
            // https://bugs.webkit.org/show_bug.cgi?id=29121
            status = 0;
            statusText = '';
            contentType = undefined;
            // FF < 14, WebKit
            // https://bugs.webkit.org/show_bug.cgi?id=29658
            // https://bugs.webkit.org/show_bug.cgi?id=77854
          }
        } else if (type !== '' && type !== 'error') {
          status = 200;
          statusText = 'OK';
          contentType = xhr.contentType;
        }
        if (contentType === undefined) {
          contentType = '';
        }

        if (status === 401) {
          tokenExpired = true;
        }

        if (status === 0 && statusText === '' && type === 'load' && responseText !== '') {
          status = 200;
          statusText = 'OK';
          if (contentType === '') {
            // Opera 12
            let tmp = /^data:([^,]*?)(?:;base64)?,[\S]*$/.exec(url);
            if (tmp !== undefined) {
              contentType = tmp[1];
            }
          }
        }
        if (status === 200 && contentTypeRegExp.test(contentType)) {
          currentState = OPEN;
          wasActivity = true;
          retry = initialRetry;
          that.readyState = OPEN;
          event = new Event('open');
          that.dispatchEvent(event);
          fire(that, that.onopen, event);
          if (currentState === CLOSED) {
            return;
          }
        } else {
          // Opera 12
          if (status !== 0 && (status !== 200 || contentType !== '')) {
            isWrongStatusCodeOrContentType = true;
          }
        }
      }

      if (currentState === OPEN) {
        if (responseText.length > charOffset) {
          wasActivity = true;
        }
        let i = charOffset - 1;
        let length = responseText.length;
        let c = '\n';
        while (++i < length) {
          c = responseText.charAt(i);
          if (state === AFTER_CR && c === '\n') {
            state = FIELD_START;
          } else {
            if (state === AFTER_CR) {
              state = FIELD_START;
            }
            if (c === '\r' || c === '\n') {
              if (field === 'data') {
                dataBuffer.push(value);
              } else if (field === 'id') {
                lastEventIdBuffer = value;
              } else if (field === 'event') {
                eventTypeBuffer = value;
              } else if (field === 'retry') {
                initialRetry = getDuration(Number(value), initialRetry);
                retry = initialRetry;
              } else if (field === 'heartbeatTimeout') {
                heartbeatTimeout = getDuration(Number(value), heartbeatTimeout);
                if (timeout !== 0) {
                  clearTimeout(timeout);
                  timeout = setTimeout(onTimeout, heartbeatTimeout);
                }
              }
              value = '';
              field = '';
              if (state === FIELD_START) {
                if (dataBuffer.length !== 0) {
                  lastEventId = lastEventIdBuffer;
                  if (eventTypeBuffer === '') {
                    eventTypeBuffer = 'message';
                  }
                  event = new MessageEvent(eventTypeBuffer, {
                    data: dataBuffer.join('\n'),
                    lastEventId: lastEventIdBuffer,
                  });
                  that.dispatchEvent(event);
                  for (let x = 0; x < EventTypes.length; x++) {
                    if (eventTypeBuffer === EventTypes[x]) {
                      let onEvent = `on${EventTypes[x]}`;
                      fire(that, that[onEvent], event);
                    }
                  }

                  if (currentState === CLOSED) {
                    return;
                  }
                }
                dataBuffer.length = 0;
                eventTypeBuffer = '';
              }
              state = c === '\r' ? AFTER_CR : FIELD_START;
            } else {
              if (state === FIELD_START) {
                state = FIELD;
              }
              if (state === FIELD) {
                if (c === ':') {
                  state = VALUE_START;
                } else {
                  field += c;
                }
              } else if (state === VALUE_START) {
                if (c !== ' ') {
                  value += c;
                }
                state = VALUE;
              } else if (state === VALUE) {
                value += c;
              }
            }
          }
        }
        charOffset = length;
      }

      if ((currentState === OPEN || currentState === CONNECTING) && (type === 'load' || type === 'error' || isWrongStatusCodeOrContentType || charOffset > 1024 * 1024 || (timeout === 0 && !wasActivity))) {
        if (isWrongStatusCodeOrContentType) {
          close();
        } else {
          currentState = WAITING;
          xhr.abort();
          if (timeout !== 0) {
            clearTimeout(timeout);
            timeout = 0;
          }
          if (retry > initialRetry * 16) {
            retry = initialRetry * 16;
          }
          if (retry > MAXIMUM_DURATION) {
            retry = MAXIMUM_DURATION;
          }
          timeout = setTimeout(onTimeout, retry);
          retry = retry * 2 + 1;

          that.readyState = CONNECTING;
        }
        event = new Event('error');
        if (tokenExpired === true) {
          event.tokenExpired = true;
          tokenExpired = false;
        }
        that.dispatchEvent(event);
        fire(that, that.onerror, event);
      } else {
        if (timeout === 0) {
          wasActivity = false;
          timeout = setTimeout(onTimeout, heartbeatTimeout);
        }
      }
    }

    function onProgress() {
      onEvent('progress');
    }

    function onLoad() {
      onEvent('load');
    }

    function onError() {
      onEvent('error');
    }

    function onReadyStateChange() {
      if (xhr.readyState === 4) {
        if (xhr.status === 0) {
          onEvent('error');
        } else {
          onEvent('load');
        }
      } else {
        onEvent('progress');
      }
    }

    if ('readyState' in xhr && global.opera !== undefined) {
      // workaround for Opera issue with "progress" events
      timeout0 = setTimeout(function f() {
        if (xhr.readyState === 3) {
          onEvent('progress');
        }
        timeout0 = setTimeout(f, 500);
      }, 0);
    }

    onTimeout = function () {
      timeout = 0;
      if (currentState !== WAITING) {
        onEvent('');
        return;
      }

      // loading indicator in Safari, Chrome < 14
      // loading indicator in Firefox
      // https://bugzilla.mozilla.org/show_bug.cgi?id=736723
      if ((!('ontimeout' in xhr) || 'sendAsBinary' in xhr || 'mozAnon' in xhr) && global.document !== undefined && global.document.readyState !== undefined && global.document.readyState !== 'complete') {
        timeout = setTimeout(onTimeout, 4);
        return;
      }

      // XDomainRequest#abort removes onprogress, onerror, onload
      xhr.onload = onLoad;
      xhr.onerror = onError;

      if ('onabort' in xhr) {
        // improper fix to match Firefox behaviour, but it is better than just ignore abort
        // see https://bugzilla.mozilla.org/show_bug.cgi?id=768596
        // https://bugzilla.mozilla.org/show_bug.cgi?id=880200
        // https://code.google.com/p/chromium/issues/detail?id=153570
        xhr.onabort = onError;
      }

      if ('onprogress' in xhr) {
        xhr.onprogress = onProgress;
      }
      // IE 8-9 (XMLHTTPRequest)
      // Firefox 3.5 - 3.6 - ? < 9.0
      // onprogress is not fired sometimes or delayed
      // see also #64
      if ('onreadystatechange' in xhr) {
        xhr.onreadystatechange = onReadyStateChange;
      }

      wasActivity = false;
      timeout = setTimeout(onTimeout, heartbeatTimeout);

      charOffset = 0;
      currentState = CONNECTING;
      dataBuffer.length = 0;
      eventTypeBuffer = '';
      lastEventIdBuffer = lastEventId;
      value = '';
      field = '';
      state = FIELD_START;

      let s = url.slice(0, 5);
      if (s !== 'data:' && s !== 'blob:') {
        s = url + ((url.indexOf('?', 0) === -1 ? '?' : '&') + 'lastEventId=' + encodeURIComponent(lastEventId) + '&r=' + (Math.random() + 1).toString().slice(2));
      } else {
        s = url;
      }
      xhr.open('GET', s, true);

      if ('withCredentials' in xhr) {
        // withCredentials should be set after "open" for Safari and Chrome (< 19 ?)
        xhr.withCredentials = withCredentials;
      }

      if ('responseType' in xhr) {
        xhr.responseType = 'text';
      }

      if ('setRequestHeader' in xhr) {
        // Request header field Cache-Control is not allowed by Access-Control-Allow-Headers.
        // "Cache-control: no-cache" are not honored in Chrome and Firefox
        // https://bugzilla.mozilla.org/show_bug.cgi?id=428916
        //xhr.setRequestHeader("Cache-Control", "no-cache");
        xhr.setRequestHeader('Accept', 'text/event-stream');
        // Request header field Last-Event-ID is not allowed by Access-Control-Allow-Headers.
        //xhr.setRequestHeader("Last-Event-ID", lastEventId);

        // Add the headers to the transport.
        let headerKeys = Object.keys(headers);
        for (let i = 0; i < headerKeys.length; i++) {
          xhr.setRequestHeader(headerKeys[i], headers[headerKeys[i]]);
        }
      }

      xhr.send(undefined);
    };

    EventTarget.call(this);
    this.close = close;
    this.url = url;
    this.readyState = CONNECTING;
    this.withCredentials = withCredentials;

    this.onopen = undefined;
    this.onmessage = undefined;
    this.onping = undefined;
    this.onerror = undefined;

    onTimeout();
  }

  function F() {
    this.CONNECTING = CONNECTING;
    this.OPEN = OPEN;
    this.CLOSED = CLOSED;
  }
  F.prototype = EventTarget.prototype;

  EventSource.prototype = new F();
  F.call(EventSource);
  if (isCORSSupported) {
    EventSource.prototype.withCredentials = undefined;
  }

  return EventSource;
})(typeof window !== 'undefined' ? window : this);

export { EventSource };
